<template>
  <div>

    <IndxHeads></IndxHeads>

    <section class="talentBg">

    </section>
    <div>

      <div class="w1024">
        <h1 class="text-left pt-50 " style="font-size: 30px;">核心团队<span class="text-uppercase text-left"
            style="font-size: 16px; color: #cccccc;margin-top: 10px;">core team</span></h1>
        <p class="line-block"></p>
        <p class="text-left fs-14  color-9">道信核心团队是承担公司发展和成长建设的重任</p>


        <div class="d-flex space-between align-center mb50 pt-50">
          <img :src="n1" alt="" class="img200 mr-50">
          <div class="fs-14 text-left">
            <h3>冯小平</h3>
            <p class="title_1">董事长、 创始人</p>
            <p class="title_2">冯小平，董事长、创始人，毕业于中国人民大学，获法学硕士学位，创办多家企业集团、拥有丰富的资本市场和多个行业的资源，积累了大量的公司管理、项目运营和投融资经验。</p>
          </div>
        </div>



        <div class="d-flex space-between align-center mb50">

          <div class="fs-14 text-left">
            <h3>李维</h3>
            <p class="title_1">总经理</p>
            <p class="title_2"> 道信资本总经理，毕业于兰州大学，曾在第一拖拉机（00038.HK）、中国矿业（00340.HK)、华腾新材（873721）等多家上市公司担任高管，专注于企业IPO和投融资。</p>
          </div>
          <img :src="n2" alt="" class="img200 ml-50">
        </div>



        <div class="d-flex space-between align-center mb50">
          <img :src="n4" alt="" class="img200 mr-50">
          <div class="fs-14 text-left">
            <h3>赖伟中</h3>
            <p class="title_1">副总经理</p>
            <p class="title_2">道信资本副总经理，毕业于中国人民大学，获得法学硕士学位，曾在北京市国资委、北京建工集团等政府部门或国企从事管理工作，联合创办过多家企业，具有丰富的企业管理及投融资实践经验。</p>
          </div>
        </div>


        <div class="d-flex space-between align-center mb50 mb50">

          <div class="fs-14 text-left">
            <h3>刘辉</h3>
            <p class="title_1">项目总监</p>
            <p class="title_2">道信资本项目总监，毕业于武汉大学，获工商管理硕士，曾任职湖北日报传媒集团、知名教育集团武汉公司总经理，具有丰富的项目运营管理经验。</p>
          </div>
          <img :src="n5" alt="" class="img200 ml-50">
        </div>

<div class="d-flex space-between align-center pb-100">
          <img :src="n3" alt="" class="img200 mr-50">
          <div class="fs-14 text-left">
            <h3>李永久</h3>
            <p class="title_1">副总经理</p>
            <p class="title_2">道信资本副总经理，兰州大学MBA,历经教育、科技、能源健康等行业，曾任多家集团公司人力资源和项目负责人，丰富的人力资源和项目管理经验。</p>
          </div>
        </div>



      </div>


    </div>


    <IndxFoot></IndxFoot>

  </div>
</template>

<script>
import bgtalnets from "@/images/rencbg.png"
import rc1 from "@/images/rc11.png"
import rc2 from "@/images/rc22.png"
import rc3 from "@/images/rc33.png"
import rc4 from "@/images/rc44.png"
import n1 from "@/images/n1.png"
import n2 from "@/images/n2.png"
import n3 from "@/images/n3.png"
import n4 from "@/images/n4.png"
import n5 from "@/images/n5.png"



import rc115 from "@/images/rc115.png"
import IndxHeads from '@/components/IndxHeads.vue'
import IndxFoot from '@/components/IndxFoot.vue'

export default {
  name: 'HomePage',
  components: {
    IndxHeads,
    IndxFoot
  },
  data() {
    return {
      bgtalnet: bgtalnets,
      rc1: rc1,
      rc2: rc2,
      rc3: rc3,
      rc4: rc4,
      n1: n1,
      n2: n2,
      n3: n3,
      n4: n4,
      n5: n5,
      rc115:rc115

    }
  },
  mounted() {

  },
  beforeUnmount() {

  },
  methods: {

  }
}
</script>

<style scoped>
.talentBg {
  background: url(/src/images/rencbg.png) no-repeat;
  background-size: cover;
  width: 100%;
  height: 500px;

}

h3 {
  font-size: 18px;
  color: #000;
}

.img200 {
  width: 250px;
  height: 250px;
  border-radius: 50%;

}

.title_1 {
  padding: 10px 0;
  color: #333333;
}

.title_2 {
  line-height: 2;
  color: #555555;
}

.mr-50 {
  margin-right: 50px;
}

.ml-50 {
  margin-left: 50px;
}

.pb-100 {
  padding-bottom: 100px;
}
</style>